import { ExpandMoreIcon } from '@dhl-ui/icons'
import type { Tokens } from '../augmentation'
import { spacing } from '../spacing'
import { type ComponentCreation } from './types'

export const createMuiSelect = ({ palette, misc }: Pick<Tokens, 'palette' | 'misc'>) =>
  ({
    MuiSelect: {
      defaultProps: {
        IconComponent: ExpandMoreIcon,
      },
      styleOverrides: {
        root: {
          backgroundColor: palette.components.input.background,

          '& .MuiSelect-select': {
            backgroundColor: palette.components.input.background,
            padding: spacing(2.5, 3, 1, 2),
            borderRadius: misc.borderRadius(),
          },

          '& .MuiNativeSelect-select': {
            backgroundColor: palette.components.input.background,
            padding: spacing(2.5, 3, 1, 2),
            borderRadius: misc.borderRadius(),
            boxSizing: 'border-box',
            height: '100%',
            minHeight: 0,
          },

          '&.MuiInputBase-sizeSmall .MuiSelect-select, &.MuiInputBase-sizeSmall .MuiNativeSelect-select': {
            padding: spacing(1.25, 3, 1.25, 2),
          },

          '&.MuiInputBase-sizeLarge .MuiSelect-select, &.MuiInputBase-sizeLarge .MuiNativeSelect-select': {
            padding: spacing(2.75, 3, 1.75, 2),
          },

          '&.MuiInputBase-sizeSmall': {
            height: spacing(5),
            maxHeight: spacing(5),
          },

          '&.MuiInputBase-sizeMedium': {
            height: spacing(6),
            maxHeight: spacing(6),
          },

          '&.MuiInputBase-sizeLarge': {
            height: spacing(7),
            maxHeight: spacing(7),
          },

          '& .MuiSelect-icon:not(.Mui-disabled), & .MuiNativeSelect-icon:not(.Mui-disabled)': {
            color: palette.pure.dark,
          },

          '& .MuiSelect-icon, & .MuiNativeSelect-icon': {
            fontSize: spacing(3),
            right: spacing(2),
          },

          '&& > .MuiNativeSelect-icon:not(.Mui-disabled)': {
            right: spacing(2),
          },

          // disabled
          '& .MuiSelect-select.Mui-disabled, & .MuiNativeSelect-select.Mui-disabled': {
            backgroundColor: palette.action.disabledBackground,
            color: palette.action.disabled,
          },

          // readonly:
          '&.Mui-readOnly .MuiSelect-select, &.Mui-readOnly .MuiNativeSelect-select': {
            backgroundColor: palette.action.disabledBackground,
          },
          '&.Mui-readOnly > .MuiSelect-icon:not(.Mui-disabled)': {
            color: palette.text.tertiary,
          },
          '&.Mui-readOnly > .MuiNativeSelect-icon:not(.Mui-disabled)': {
            color: palette.text.tertiary,
          },
        },
        select: {
          '&:focus': {
            // TODO: what will we do in style
          },
        },
        outlined: {
          minHeight: 'unset',
          height: spacing(2.5),
          maxHeight: spacing(2.75),
          lineHeight: spacing(2.75),
        },
      },
    },
    MuiNativeSelect: {
      styleOverrides: {
        select: {
          boxSizing: 'border-box',
          height: '100%',
          minHeight: 0,
        },
      },
    },
  }) satisfies ComponentCreation
